export const JBTMarelCrossLogo = (): JSX.Element => {
  const className = 'icons indexed-icons--jbt-marel-cross-logo';

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.4445 19.5555H0V12.4445H12.4445V19.5555ZM32 12.4445H19.5555V19.5555H32V12.4445ZM12.4445 0V5.33339C12.4445 9.26074 15.6282 12.4445 19.5555 12.4445V0H12.4445ZM19.5555 19.5555C15.6282 19.5555 12.4445 22.7393 12.4445 26.6666V32H19.5555V19.5555Z"
        fill="white"
      />
    </svg>
  );
};
